import { render, staticRenderFns } from "./LineItems.vue?vue&type=template&id=0ddd1e80&scoped=true&"
import script from "./LineItems.vue?vue&type=script&lang=js&"
export * from "./LineItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd1e80",
  null
  
)

export default component.exports